import { render, staticRenderFns } from "./HeaderPageV2.vue?vue&type=template&id=b162fc96&scoped=true"
import script from "./HeaderPageV2.vue?vue&type=script&lang=js"
export * from "./HeaderPageV2.vue?vue&type=script&lang=js"
import style0 from "./HeaderPageV2.vue?vue&type=style&index=0&id=b162fc96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b162fc96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b162fc96')) {
      api.createRecord('b162fc96', component.options)
    } else {
      api.reload('b162fc96', component.options)
    }
    module.hot.accept("./HeaderPageV2.vue?vue&type=template&id=b162fc96&scoped=true", function () {
      api.rerender('b162fc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/HeaderPageV2.vue"
export default component.exports